import React from 'react'
import { FaGithub, FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div
      style={{
        width: "100%",
        background: "#13151a",
        border: "1px solid #1e2228",
        borderRadius: "12px",
        padding: "28px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
      }}
      className="lgl:w-[35%]"
    >
      {/* Photo */}
      <div style={{ position: "relative", borderRadius: "10px", overflow: "hidden" }}>
        <img
          src={contactImg}
          alt="Biprodas Barai"
          style={{ width: "100%", height: "220px", objectFit: "cover", display: "block" }}
        />
        <div style={{
          position: "absolute",
          bottom: 0, left: 0, right: 0,
          height: "60px",
          background: "linear-gradient(to top, #13151a, transparent)",
        }} />
      </div>

      {/* Info */}
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <h3 style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: "22px",
          fontWeight: 800,
          color: "#f0f2f5",
          letterSpacing: "-0.02em",
        }}>
          Biprodas Barai
        </h3>
        <p style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "12px",
          color: "#ff014f",
        }}>
          Backend & Platform Engineer
        </p>
        <div style={{
          marginTop: "8px",
          padding: "12px",
          background: "#0f1114",
          border: "1px solid #1e2228",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}>
          <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "12px", color: "#8892a4" }}>
            <span style={{ color: "#4a5568" }}>// phone</span>
          </p>
          <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "12px", color: "#f0f2f5" }}>
            +880 1720-926738
          </p>
          <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "12px", color: "#8892a4", marginTop: "4px" }}>
            <span style={{ color: "#4a5568" }}>// email</span>
          </p>
          <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "12px", color: "#f0f2f5" }}>
            biprodas.barai@gmail.com
          </p>
        </div>
      </div>

      {/* Social */}
      <div>
        <p style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "11px",
          color: "#4a5568",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          marginBottom: "12px",
        }}>
          // find_me_at
        </p>
        <div className="flex gap-3">
          <span className="bannerIcon">
            <a href="https://www.facebook.com/bipro.barai.503" target="_blank" rel="noreferrer"><FaFacebookF /></a>
          </span>
          <span className="bannerIcon">
            <a href="https://github.com/bipro-b?tab=repositories" target="_blank" rel="noreferrer"><FaGithub /></a>
          </span>
          <span className="bannerIcon">
            <a href="https://www.linkedin.com/in/bipro-barai-419381179/" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft;